import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VContainer,{staticClass:"white text-left",attrs:{"grid-list-md":""}},[_c(VRow,[_c(VCol,{staticClass:"body-2 grey--text text-left pb-0",attrs:{"cols":"12"}},[_c('div',[_c(VBreadcrumbs,{attrs:{"items":_vm.routeItems,"divider":">"}})],1)])],1),_c(VRow,[_c(VCol,{staticClass:"headline pb-0",attrs:{"cols":"12"}},[_vm._v("No. Pedido: "+_vm._s(_vm.dataOrder.saleOrderID))]),_c(VCol,{staticClass:"headline pb-0",attrs:{"cols":"12"}},[_vm._v("No. Orden: "+_vm._s(_vm.dataOrder.id))]),_c(VCol,{staticClass:"pt-0 grey--text title",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.dataOrder.location))])],1),_c(VRow,[_c(VCol,{staticClass:"headline body-1 pb-0",attrs:{"cols":"12"}},[_c('span',{staticClass:"grey--text font-weight-regular"},[_vm._v("Contacto:")]),_vm._v("\n        "+_vm._s(_vm.dataOrder.userContact)+"\n      ")]),_c(VCol,{staticClass:"headline body-1 pt-0",attrs:{"cols":"12"}},[_c('span',{staticClass:"grey--text"},[_vm._v("Tel:")]),_vm._v("\n        "+_vm._s(_vm.dataOrder.userPhone)+"\n      ")])],1)],1),(!_vm.exist)?_c(VContainer,[_c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v("El pedido que buscaste no pudo ser encontrado.")])],1)],1):_vm._e(),_vm._l((_vm.dataEquipment),function(data,index){return _c(VContainer,{directives:[{name:"show",rawName:"v-show",value:(_vm.exist),expression:"exist"}],key:data.key,staticClass:"pt-0"},[_c(VCol,{staticClass:"pb-0",attrs:{"cols":"12"}},[_c(VCard,{staticClass:"pa-2"},[_vm._v("\n        "+_vm._s(data.correctStatus)+"\n        "),_c('p',{staticClass:"title ml-1 mt-2 mb-0 font-weight-regular"},[_vm._v("\n          No. Serie: "+_vm._s(data.machineSerie)+"\n        ")]),_c('p',{staticClass:"subheading ml-1 mt-1 mb-0 font-weight-light"},[_vm._v("\n          Modelo del equipo: "+_vm._s(data.machineModel)+"\n        ")]),_c('p',{staticClass:"subheading ml-1 mt-0 mb-0 font-weight-light text-uppercase"},[_vm._v("\n          "+_vm._s(data.machineDescription)+"\n        ")])])],1),_c(VCol,{staticClass:"pt-0",attrs:{"cols":"12"}},[_c(VExpansionPanels,[_c(VExpansionPanel,[_c(VExpansionPanelHeader,{staticClass:"pa-2",scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c(VIcon,[_vm._v("add")])]},proxy:true}],null,true)},[_c('span',{staticClass:"red--text font-weight-light"},[_vm._v("\n              Realizar Checklist - "+_vm._s(_vm.onlyStatus(index).name)+"("+_vm._s(_vm.onlyStatus(index).onlyLetter)+")\n            ")])]),_c(VExpansionPanelContent,{staticClass:"background-gray"},[_c(VContainer,{staticClass:"pa-0"},[_c(VRow,[_c(VCol,{staticClass:"caption pb-0",attrs:{"cols":"12"}},[_vm._v("Proceso de entrega")]),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'delivery',
                        'output',
                        data.machineSerie,
                        { event: 'Entrega', inputOuput: 'Salida' },
                        'deliveryOutput',
                        index,
                        data.statusMap.delivery.output ? 'consult' : 'save',
                        data.status === 'deliveryOutput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'deliveryOutput',
                        'delivery',
                        'output'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Salida")]),(
                        data.status == 'deliveryOutput' &&
                          !data.statusMap.delivery.output
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.delivery.output)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'delivery',
                        'input',
                        data.machineSerie,
                        { event: 'Entrega', inputOuput: 'Entrada' },
                        'deliveryInput',
                        index,
                        data.statusMap.delivery.input ? 'consult' : 'save',
                        data.status === 'deliveryInput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'deliveryInput',
                        'delivery',
                        'input'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Entrada")]),(
                        data.status == 'deliveryInput' &&
                          !data.statusMap.delivery.input
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.delivery.input)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1)],1),_c(VRow,[_c(VCol,{staticClass:"caption pb-0",attrs:{"cols":"12"}},[_vm._v("En periodo de renta / Mantenimiento")]),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'maintenance',
                        'output',
                        data.machineSerie,
                        { event: 'Mantenimiento', inputOuput: 'Salida' },
                        'maintenanceOutput',
                        index,
                        data.statusMap.maintenance.output
                          ? 'consult'
                          : 'save',
                        data.status === 'maintenanceOutput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'maintenanceOutput',
                        'maintenance',
                        'output'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Salida")]),(
                        data.status == 'maintenanceOutput' &&
                          !data.statusMap.maintenance.output
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.maintenance.output)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'maintenance',
                        'input',
                        data.machineSerie,
                        { event: 'Mantenimiento', inputOuput: 'Entrada' },
                        'maintenanceInput',
                        index,
                        data.statusMap.maintenance.input ? 'consult' : 'save',
                        data.status === 'maintenanceInput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'maintenanceInput',
                        'maintenance',
                        'input'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Entrada")]),(
                        data.status == 'maintenanceInput' &&
                          !data.statusMap.maintenance.input
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.maintenance.input)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1)],1),_c(VRow,[_c(VCol,{staticClass:"caption pb-0",attrs:{"cols":"12"}},[_vm._v("Recolección")]),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'recollection',
                        'output',
                        data.machineSerie,
                        { event: 'Recolección', inputOuput: 'Salida' },
                        'recollectionOutput',
                        index,
                        data.statusMap.recollection.output
                          ? 'consult'
                          : 'save',
                        data.status === 'recollectionOutput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'recollectionOutput',
                        'recollection',
                        'output'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Salida")]),(
                        data.status == 'recollectionOutput' &&
                          !data.statusMap.recollection.output
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.recollection.output)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'recollection',
                        'input',
                        data.machineSerie,
                        { event: 'Recolección', inputOuput: 'Entrada' },
                        'recollectionInput',
                        index,
                        data.statusMap.recollection.input
                          ? 'consult'
                          : 'save',
                        data.status === 'recollectionInput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'recollectionInput',
                        'recollection',
                        'input'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Entrada")]),(
                        data.status == 'recollectionInput' &&
                          !data.statusMap.recollection.input
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.recollection.input)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1)],1),_c(VRow,[_c(VCol,{staticClass:"caption pb-0",attrs:{"cols":"12"}},[_vm._v("Reubicación")]),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'relocation',
                        'output',
                        data.machineSerie,
                        { event: 'Reubicación', inputOuput: 'Salida' },
                        'relocationOutput',
                        index,
                        data.statusMap.relocation.output ? 'consult' : 'save',
                        data.status === 'relocationOutput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'relocationOutput',
                        'relocation',
                        'output'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Salida")]),(
                        data.status == 'relocationOutput' &&
                          !data.statusMap.relocation.output
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.relocation.output)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'relocation',
                        'input',
                        data.machineSerie,
                        { event: 'Reubicación', inputOuput: 'Entrada' },
                        'relocationInput',
                        index,
                        data.statusMap.relocation.input ? 'consult' : 'save',
                        data.status === 'relocationInput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'relocationInput',
                        'relocation',
                        'input'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Entrada")]),(
                        data.status == 'relocationInput' &&
                          !data.statusMap.relocation.input
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.relocation.input)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1)],1),_c(VRow,[_c(VCol,{staticClass:"caption pb-0",attrs:{"cols":"12"}},[_vm._v("Rentado Servicio")]),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'rented-service',
                        'output',
                        data.machineSerie,
                        {
                          event: 'Rentado Servicio',
                          inputOuput: 'Salida'
                        },
                        'rented-serviceOutput',
                        index,
                        data.statusMap.rentedService.output
                          ? 'consul'
                          : 'save',
                        data.status === 'rented-serviceOutput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'rented-serviceOutput',
                        'rentedService',
                        'output'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Salida")]),(
                        data.status == 'rented-serviceOutput' &&
                          !data.statusMap.rentedService.output
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.rentedService.output)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1),_c(VCol,{attrs:{"cols":"12 pt-0"}},[_c(VBtn,_vm._b({staticClass:"d-flex justify-space-between",attrs:{"block":""},on:{"click":function($event){return _vm.goToChecklist(
                        data.key,
                        'rented-service',
                        'input',
                        data.machineSerie,
                        {
                          event: 'Rentado Servicio',
                          inputOuput: 'Entrada'
                        },
                        'rented-serviceInput',
                        index,
                        data.statusMap.rentedService.input
                          ? 'consult'
                          : 'save',
                        data.status === 'rented-serviceInput'
                      )}}},'v-btn',
                      _vm.getChecklistColor(
                        data,
                        'rented-serviceInput',
                        'rentedService',
                        'input'
                      )
                    ,false),[_c('span',{staticClass:"text-uppercase"},[_vm._v("Entrada")]),(
                        data.status == 'rented-serviceInput' &&
                          !data.statusMap.rentedService.input
                      )?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("realizar checklist")]):(data.statusMap.rentedService.input)?_c('span',{staticClass:"text-capitalize caption"},[_vm._v("Checklist Realizado")]):_c('span',{staticClass:"text-capitalize caption"},[_vm._v("por realizar")])])],1)],1)],1)],1)],1)],1)],1)],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }